export const parentInactiveReasons = [
  'Contact information is incorrect / no way to contact',
  'Duplicate record',
  'Did not respond to multiple outreach attempts',
  'Did not register for orientation',
  'Registered but did not complete orientation',
  'Did not respond to AC for post-orientation meeting',
  'Did not complete licensing process',
  'Family is working with LCPA',
  'Is only interested in foster care at this time',
  'Has foster placement &amp; is not interested in remaining active',
  'Issue with foster license needs to be resolved',
  'License voluntarily withdrawn',
  'Recently adopted &amp; is not interested in remaining active',
  'Out of state agency did not submit requested documents',
  'OOS without home study or license',
  'Family is no longer interested in adopting',
  'Other (please specify)',
].map((s) => ({ id: s, name: s }));

export const parentFlagReasons = [
  'Has pre-adoptive placement',
  'Family currently at capacity',
  'Consultant Conversation Needed',
  'Placement Hold',
  'Adopted non-IAP child',
].map((s) => ({ id: s, name: s }));

export const childCharacteristics = [
  { key: 'experienceWithAutism', label: 'Experience with autism' },
  { key: 'experinceWithHighMedicalNeeds', label: 'Experience with high medical needs' },
  { key: 'openToLGBTQ', label: 'Open to LGBTQ' },
  { key: 'adoptedPreviously', label: 'Adopted previously' },
  { key: 'therapeuticCertificate', label: 'Therapeutic certificate' },
  { key: 'bilingual', label: 'Bilingual' },
  { key: 'hasFamilyProfileOrVideo', label: 'Has family profile or video' },
  { key: 'eligibleForSafeHavenInfant', label: 'Eligible for safe haven infant' },
];
